import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PlusCircle, Loader2 } from "lucide-react";

import AdditionalParameter from "../../Components/StakingRisk/product/AdditionalParameter";
import { Button } from "../../Components/StakingRisk/ui/button";
import { Input } from "../../Components/StakingRisk/ui/input";

export default function CreateCategory() {

  const navigate = useNavigate();

  const [error, setError] = useState("");  
  const [isCreating, setIsCreating] = useState(false);
  const [productName, setProductName] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsCreating(true);
    };

  return (
    <div className="p-6 max-w-7xl mx-auto  min-h-[calc(100vh-8rem)]">
      <div>
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
        Create New Category
      </h1>
      </div>     
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="product-name" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Category Name
              </label>
              <Input
                id="category-name"
                placeholder="Enter category name"
                value={productName}
                onChange={(e) => {
                  setProductName(e.target.value);
                  setError("");
                }}
                className={error ? "border-red-500" : ""}
                autoFocus
              />
              {error && <p className="text-sm text-red-500">{error}</p>}
            </div>
            
            <AdditionalParameter/>
            <Button 
              type="submit" 
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              disabled={isCreating}
            >
              {isCreating ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Creating...
                </>
              ) : (
                <>
                  <PlusCircle className="mr-2 h-4 w-4" />
                  Create Category
                </>
              )}
            </Button>
            
            <div className="flex justify-center">
              <Button 
                type="button" 
                variant="ghost" 
                onClick={() => navigate("/stakingrisk/dashboard")}
                disabled={isCreating}
              >
                Cancel
              </Button>
            </div>
          </form>   
     
    </div>
  );
}